import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import { createEpicMiddleware } from 'redux-observable'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

import { immutableReconciler } from '../data/reconciler'
import * as actions from './actions'
import { rootEpic } from './epic'
import { rootReducer } from './reducer'

const config = {
  key: 'srprsme_website',
  storage,
  stateReconciler: immutableReconciler,
  blacklist: ['contentEngine', 'unlockPage', 'paymentOrder', 'page'],
}

const epicMiddleware = createEpicMiddleware<any>()

const reducer = (persistReducer(
  config,
  rootReducer,
) as unknown) as typeof rootReducer

// https://github.com/zalmoxisus/redux-devtools-extension#14-using-in-production
const composeEnhancers = composeWithDevTools({})

export const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(thunk, epicMiddleware)),
)

export const init = () => {
  epicMiddleware.run(rootEpic)
  store.dispatch(actions.init())
}

export const persistor = persistStore(store)

init()
